import React from 'react';
import { Button, Card } from 'react-bootstrap';
import RouteAccessMiddleware from '../../Middleware/RouteAccessMiddleware';
import Loader from '../../Loader';
import { AiOutlineInfoCircle } from 'react-icons/ai';
var UICardContainer = function UICardContainer(_ref) {
    var title = _ref.title, onClick = _ref.onClick, btnName = _ref.btnName, routeRequest = _ref.routeRequest, isLoading = _ref.isLoading, children = _ref.children, idTitle = _ref.idTitle, link = _ref.link;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoading && /*#__PURE__*/ React.createElement(Loader, null), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Header, null, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex align-items-center justify-content-between"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex gap-2"
    }, /*#__PURE__*/ React.createElement("h5", {
        id: idTitle
    }, title), link && /*#__PURE__*/ React.createElement("a", {
        className: "text-decoration-none text-dark",
        href: link,
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement(AiOutlineInfoCircle, null))), routeRequest && /*#__PURE__*/ React.createElement(RouteAccessMiddleware, {
        routeRequest: routeRequest
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "float-right",
        onClick: onClick
    }, btnName)))), /*#__PURE__*/ React.createElement(Card.Body, null, children)));
};
export default UICardContainer;
